import * as yup from 'yup';
import { ConditioningType } from 'types';

export const MaterialFormSchema = (
  t: (key: string, options?: { [key: string]: string }) => string,
): yup.AnyObjectSchema =>
  yup.object().shape({
    shortName: yup.string().required(t('form.errors.missingShortName')),
    standard: yup.string().required(t('form.errors.missingStandard')),
    conditioningType: yup.string().required(t('form.errors.missingConditioningType')),
    averageWeight: yup.lazy(materialConditioningAverageWeight => {
      return yup
        .number()
        .transform(value => (isNaN(value) ? undefined : value))
        .test('averageWeightValidation', t('form.errors.missingAverageWeight'), (value, context) => {
          if (ConditioningType.Bulk.toString() === context?.parent?.conditioningType?.toString()) {
            return true;
          }
          return undefined !== value && value > 0.0001;
        });
    }),
  });
